import {Component, DestroyRef, inject, input, model, output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {Button} from 'primeng/button';
import {Dialog} from 'primeng/dialog';
import {Textarea} from 'primeng/textarea';
import {CommentContainer} from './comment-container';

@Component({
  selector: 'app-comment-modal-x',
  imports: [FormsModule, Button, Dialog, Textarea, TranslocoPipe],
  templateUrl: './comment-modal-x.component.html',
})
export class CommentModalXComponent {
  readonly visible = model(false);

  readonly commentContainer = model.required<CommentContainer>();
  readonly isReadOnly = input(false);
  readonly placeholderKey = input('comments.placeholder');

  readonly save = output<string>();

  constructor() {
    // When this Dlg is in another DLg press ESC will close only this Dlg
    document.addEventListener('keydown', this.onEscapeCapture, true);
    inject(DestroyRef).onDestroy(() =>
      document.removeEventListener('keydown', this.onEscapeCapture, true),
    );
  }

  close(): void {
    this.visible.set(false);
  }

  sendComment(): void {
    const value = this.commentContainer().comment?.trim();
    this.save.emit(value ?? '');
    this.visible.set(false);
  }

  clearComment(): void {
    this.commentContainer.set({
      ...this.commentContainer(),
      comment: '',
    });
    this.save.emit('');
    this.visible.set(false);
  }

  private readonly onEscapeCapture = (event: KeyboardEvent): void => {
    if (event.key === 'Escape' && this.visible()) {
      event.stopImmediatePropagation();
      this.close();
    }
  };
}
